import { motion } from 'framer-motion';

const DownArrowIcon = ({ spin = false, ...props }) => {
  const { color = 'var(--pcm-body-color-secondary)' } = props;

  const variants = {
    up: { rotate: 180 },
    down: { rotate: 0 },
  };

  return (
    <motion.svg
      width='8'
      height='8'
      viewBox='0 0 8 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      animate={spin ? 'up' : 'down'}
      variants={variants}
      {...props}
    >
      <g clipPath='url(#clip0_0_12077)'>
        <rect
          x='0.353892'
          y='0.708008'
          width='0.500478'
          height='5.00478'
          transform='rotate(-45 0.353892 0.708008)'
          fill={color}
          stroke={color}
          strokeWidth='0.500478'
        />
        <rect
          x='7.09778'
          y='0.354136'
          width='0.500478'
          height='5.00478'
          transform='rotate(45 7.09778 0.354136)'
          fill={color}
          stroke={color}
          strokeWidth='0.500478'
        />
      </g>
      <defs>
        <clipPath id='clip0_0_12077'>
          <rect width='7.80557' height='4.60059' fill='white' transform='translate(0 0.000244141)' />
        </clipPath>
      </defs>
    </motion.svg>
  );
};

export default DownArrowIcon;
